document.addEventListener('DOMContentLoaded', function () {
  // strores page
  const storeContainers = document.querySelectorAll('.store-container');
  
  if (storeContainers.length === 0) return;

  storeContainers.forEach(container => {
    const slider = container.querySelector('.swiper');
    const prev = container.querySelector('.swiper-button-prev');
    const next = container.querySelector('.swiper-button-next');
    const pagination = container.querySelector('.swiper-pagination');

    if (slider && prev && next) {
      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        freeMode: false,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: pagination,
          clickable: true,
        }
      });
    }
  });
});



// collection description toggle
document.addEventListener("DOMContentLoaded", () => {
  const descriptionElement = document.querySelector('.CollectionDescription_Text');
  const toggleButton = document.getElementById('toggle-button-collection');

  if (descriptionElement && toggleButton) {
    const viewMore = toggleButton.getAttribute('data-view-more');
    const viewLess = toggleButton.getAttribute('data-view-less');
    const maxHeight = 100; // Adjust height limit

    function toggleDescription() {
      if (descriptionElement.classList.contains("collapsed")) {
        descriptionElement.style.maxHeight = "none";
        descriptionElement.classList.remove("collapsed");
        toggleButton.innerHTML = viewLess;
      } else {
        descriptionElement.style.maxHeight = maxHeight + "px";
        descriptionElement.classList.add("collapsed");
        toggleButton.innerHTML = viewMore;
      }
    }

    descriptionElement.classList.remove('hide'); // Ensure it becomes visible
    toggleButton.style.display = "block"; // Always show the button
    toggleButton.addEventListener("click", toggleDescription);
  }
});
